import React from 'react';
import { OptionCard } from './OptionCard';

const displayOptions = [
  {
    icon: "⚡",
    title: "Select and Optimize",
    description: "Optimize the budgets for your partner selection",
    link: "/partners/display/optimize"
  },
  {
    icon: "🤝",
    title: "View Deals",
    description: "View available direct display partnership deals",
    link: "/partners/display/deals"
  },
  {
    icon: "📊",
    title: "View RFP Scorecard",
    description: "Review and manage partner RFP responses",
    link: "/partners/display/rfp-scorecard"
  }
];

export function DirectDisplayPartnersPage() {
  return (
    <main className="main-content">
      <h1 className="page-title">Direct Display Partners</h1>
      
      <div className="options-grid">
        {displayOptions.map((option, index) => (
          <OptionCard 
            key={index}
            icon={option.icon}
            title={option.title}
            description={option.description}
            link={option.link}
          />
        ))}
      </div>
    </main>
  );
} 